import { render, staticRenderFns } from "./MyVideo.vue?vue&type=template&id=1d6f20ae&scoped=true&"
import script from "./MyVideo.vue?vue&type=script&lang=js&"
export * from "./MyVideo.vue?vue&type=script&lang=js&"
import style0 from "./MyVideo.vue?vue&type=style&index=0&id=1d6f20ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f20ae",
  null
  
)

export default component.exports